import { render, staticRenderFns } from "./BindBox.vue?vue&type=template&id=eeee8cb6&scoped=true"
import script from "./BindBox.vue?vue&type=script&lang=js"
export * from "./BindBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeee8cb6",
  null
  
)

export default component.exports